import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateBill = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/stores/${activeStore}/bills/create`);
};

export const useGetBills = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/stores/${activeStore}/bills/list${queryData}`);
  return data;
};

export const useGetBillData = (clientId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    clientId ? `/users/stores/${activeStore}/bills/${clientId}` : null
  );
};

export const useUpdateBill = (billId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/stores/${activeStore}/bills/${billId}`);
};

export const useDeleteBill = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (billId: number) => {
      return deleteReq(`/users/stores/${activeStore}/bills/${billId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};
